import { cn } from '@atlas/ui-primitives'
import type { PromptLifecycle } from '@/domain/prompt.types'
import { PROMPT_LIFECYCLE_COLOR, PROMPT_LIFECYCLE_LABEL } from '@/domain/prompt.types'

export interface PromptLifecyclePillProps {
	lifecycle: PromptLifecycle
	className?: string
}

/**
 * Lifecycle badge. Colour carries the same meaning as in the Rules explorer
 * (neutral draft, success live, warning retired) so the two libraries read alike.
 */
export function PromptLifecyclePill({ lifecycle, className }: PromptLifecyclePillProps) {
	return (
		<span
			className={cn(
				'inline-flex items-center rounded-ds-full border px-2 py-0.5 text-ds-2xs font-medium',
				PROMPT_LIFECYCLE_COLOR[lifecycle],
				className,
			)}
		>
			{PROMPT_LIFECYCLE_LABEL[lifecycle]}
		</span>
	)
}
